import { type OperationResponse } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

interface OperationMethods {
  "generateExampleCsvFile"(
    parameters?: null,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GenerateExampleCsvFile.Responses.$200>;
  "generateExamplePdfFile"(
    parameters?: null,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GenerateExamplePdfFile.Responses.$200>;
  "importFiles"(
    parameters?: null,
    data?: Paths.importFiles.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.importFiles.Responses.$200>;
}

export const getProductsImportOperations = (client: AxiosInstance) => {
  const generateExampleCsvFile: OperationMethods["generateExampleCsvFile"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/system/products-import/example.csv";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  const generateExamplePdfFile: OperationMethods["generateExamplePdfFile"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/system/products-import/doc.pdf";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  const importFiles: OperationMethods["importFiles"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/system/products-import/csv";
    return client.post(replacePathParameters(url, parameters), data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  return {
    generateExampleCsvFile,
    generateExamplePdfFile,
    importFiles,
  };
};
